module.exports = __webpack_public_path__ + "static/media/images_section_img2.af32e35d.png";